import { axios } from "../config/axios";
import {
  IAffiliate,
  IAffiliateFinancialDetail,
  IAffiliateFinancialSummaries,
  IAffiliates,
  IPayoutProcessDto,
  IPayoutRequests
} from "../interfaces/endpoints/IAffiliates";
import { IAxiosResponse } from "../interfaces/IAxiosResponse";
import { serialize } from "../utils/serializeToQueryString";

export type getAllAffiliatesParamsType = {
  pageIndex: number;
  searchKeyword?: string;
  status?: number;
};

export type getPayoutRequestsParamsType = {
  pageIndex: number;
  affiliateId?: number;
  status?: number;
};

export const getAllAffiliates = async (
  att: getAllAffiliatesParamsType
): Promise<IAxiosResponse<IAffiliates>> => {
  return axios.get<IAffiliates>(`Affiliate/Affiliates${serialize(att)}`);
};

export const getAffiliateById = async (
  id: number
): Promise<IAxiosResponse<IAffiliate>> => {
  return axios.get<IAffiliate>(`Affiliate/AffiliateById/${id}`);
};

export const createAffiliate = async (
  body: Partial<IAffiliate>
): Promise<number> => {
  return axios.post("Affiliate/Affiliate", body);
};

export const updateAffiliate = async (
  body: Partial<IAffiliate>,
  id: number
): Promise<boolean> => {
  return axios.put(`Affiliate/Affiliate/${id}`, body);
};

export const approveAffiliate = async (id: number): Promise<boolean> => {
  return axios.put(`Affiliate/Approve/${id}`);
};

export const rejectAffiliate = async (
  id: number,
  adminNote: string
): Promise<boolean> => {
  return axios.put(`Affiliate/Reject/${id}`, JSON.stringify(adminNote), {
    headers: { "Content-Type": "application/json" }
  });
};

export const suspendAffiliate = async (
  id: number,
  adminNote: string
): Promise<boolean> => {
  return axios.put(`Affiliate/Suspend/${id}`, JSON.stringify(adminNote), {
    headers: { "Content-Type": "application/json" }
  });
};

export const deleteAffiliate = async (id: number): Promise<boolean> => {
  return axios.delete(`Affiliate/DeleteAffiliate/${id}`);
};

export const getPayoutRequests = async (
  att: getPayoutRequestsParamsType
): Promise<IAxiosResponse<IPayoutRequests>> => {
  return axios.get<IPayoutRequests>(
    `Affiliate/PayoutRequests${serialize(att)}`
  );
};

export const processPayout = async (
  id: number,
  body: IPayoutProcessDto
): Promise<boolean> => {
  return axios.put(`Affiliate/ProcessPayout/${id}`, body);
};

export const generateAffiliatePromoCode = async (
  name: string
): Promise<IAxiosResponse<string>> => {
  return axios.get<string>(`Affiliate/GeneratePromoCode?name=${encodeURIComponent(name)}`);
};

export type getFinancialSummariesParamsType = {
  pageIndex: number;
  searchKeyword?: string;
  status?: number;
};

export const getAffiliateFinancialSummaries = async (
  att: getFinancialSummariesParamsType
): Promise<IAxiosResponse<IAffiliateFinancialSummaries>> => {
  return axios.get<IAffiliateFinancialSummaries>(
    `Affiliate/FinancialSummaries${serialize(att)}`
  );
};

export const getAffiliateFinancialDetail = async (
  id: number
): Promise<IAxiosResponse<IAffiliateFinancialDetail>> => {
  return axios.get<IAffiliateFinancialDetail>(
    `Affiliate/FinancialDetail/${id}`
  );
};
